export enum ESegmentsName {
	EV_SEGMENT_ELECTRIC = 'Segment EV (Elektryczne)',
	B_SEGMENT = 'Segment B',
	SEGMENT_B_PLUS_AUTOMATIC = 'Segment B+ (Automat)',
	C_SEGMENT = 'Segment C',
	SEGMENT_C_PLUS_COMBI = 'Segment C+ (Kombi)',
	SEGMENT_C_PLUS_AUTOMATIC = 'Segment C+ (Automat)',
	SEGMENT_C_PLUS_COMBI_AUTOMATIC = 'Segment C+ (Kombi Automat)',
	SEGMENT_CROSSOVER_AUTOMATIC = 'Segment CROSSOVER (Automat)',
	SUV_SEGMENT = 'Segment SUV',
	SUV_SEGMENT_AUTOMATIC = 'Segment SUV (Automat)',
	SEGMENT_CROSSOVER_PREMIUM = 'Segment CROSSOVER PREMIUM',
	SEGMENT_E_PREMIUM_AUTOMATIC = 'Segment E PREMIUM (Automat)',
	SEGMENT_F_PREMIUM_AUTOMATIC = 'Segment F PREMIUM (Automat)',
	SUV_PREMIUM_AUTOMATIC_4X4_SEGMENT = 'Segment SUV PREMIUM (Automat) 4x4',
	SEGMENT_R_BUS_9_PERSON = 'Segment R (Bus 9-osobowe)',
	SEGMENT_R_BUS_9_PERSON_AUTOMATIC = 'Segment R (Bus 9-osobowe) - Automat',
}

export const segmentsMapTranslations: { [key: string]: string } = {
	[ESegmentsName.EV_SEGMENT_ELECTRIC]: 'ev_segment_electric',
	[ESegmentsName.B_SEGMENT]: 'b_segment',
	[ESegmentsName.SEGMENT_B_PLUS_AUTOMATIC]: 'segment_b_plus_automatic',
	[ESegmentsName.C_SEGMENT]: 'c_segment',
	[ESegmentsName.SEGMENT_C_PLUS_COMBI]: 'segment_c_plus_combi',
	[ESegmentsName.SEGMENT_C_PLUS_AUTOMATIC]: 'segment_c_plus_automatic',
	[ESegmentsName.SEGMENT_C_PLUS_COMBI_AUTOMATIC]: 'segment_c_plus_combi_automatic',
	[ESegmentsName.SEGMENT_CROSSOVER_AUTOMATIC]: 'segment_crossover_automatic',
	[ESegmentsName.SUV_SEGMENT]: 'suv_segment',
	[ESegmentsName.SUV_SEGMENT_AUTOMATIC]: 'suv_segment_automatic',
	[ESegmentsName.SEGMENT_CROSSOVER_PREMIUM]: 'segment_crossover_premium',
	[ESegmentsName.SEGMENT_E_PREMIUM_AUTOMATIC]: 'segment_e_premium_automatic',
	[ESegmentsName.SEGMENT_F_PREMIUM_AUTOMATIC]: 'segment_f_premium_automatic',
	[ESegmentsName.SUV_PREMIUM_AUTOMATIC_4X4_SEGMENT]: 'suv_premium_automatic_4x4_segment',
	[ESegmentsName.SEGMENT_R_BUS_9_PERSON]: 'segment_r_bus_9_person',
	[ESegmentsName.SEGMENT_R_BUS_9_PERSON_AUTOMATIC]: 'segment_r_bus_9_person_automatic',
}

export const CARS_SLIDER_COUNT_PER_SEGMENT = 2
